module.exports = __webpack_public_path__ + "static/media/106-smartphone.3048295b.svg";